<template>
    <!-- 全部分类 -->
    <div class="titles">
        <div class="titles-head">
            <span>全部分类</span>
            <span class="iconfont icon-liebiao"></span>
        </div>
        <div class="titles-main">
            <div :class="{'titles-cell':true,'left-cell':(index%2==0), 'right-cell':(index%2!=0)}" v-for="(item,index) in list" :key="index">
                <el-button type="text">{{item.title}}</el-button>
            </div>
        </div>
    </div>
</template>
<script>
export default {
  data() {
    return {};

  },
  props: ["list"]
};
</script>
<style lang="less">
.titles {
  height: 100%;
  .titles-head {
    text-align: center;
    background-color: red;
    color: white;
    margin-bottom: 20px;
    height: 30px;
  }
  .titles-main {
    overflow: auto;
    position: absolute;
    top: 50px;
    bottom: 0px;
    left: 0px;
    right: 0px;
    .titles-cell {
      width: 50%;
      float: left;
      text-align: center;
      background-color: #e4e4e4;
      box-sizing: border-box;
      border-bottom: 2px solid white;
    }
    .right-cell{
        border-left: 1px solid white
    }
    .left-cell{
        border-right: 1px solid white
    }
  }
}
</style>





// WEBPACK FOOTER //
// src/components/titles.vue